<template>
  <div>
  <form id="registration-form" class="registration-form validate-form" @submit.prevent="createInvestor">
    <div class="form-group">
      <label for="first_name"></label>
      <input id="first_name" type="text" class="form-control" name="first_name" placeholder="First Name" required v-model="profile.first_name">
      <label for="last_name"></label>
      <input id="last_name" type="text" class="form-control" name="last_name" placeholder="Last Name" required v-model="profile.last_name">
      <label for="email"></label>
      <input id="email" type="text" class="form-control" name="email" placeholder="Email" required v-model="profile.email">
      <div v-if="errors.email !== ''" class="checkbox checkbox-primary">
      <field-error :error-message="errors.email"></field-error>
      <input id="add_existing" name="add_existing" type="checkbox" class="styled" v-model="profile.add_existing" @change="addExistingInvestor">
      <label for="add_existing">Add this investor?</label>
      </div>
      <select id="country" class="form-control" name="country" required v-model="profile.country">
        <option value="" disabled="disabled">--Select Country--</option>
        <option v-for="option in locationOptions.countryOptions" :value="option.code">
          {{ option.name }}
        </option>
      </select>
      <label for="region"></label>
      <select id="region" class="form-control" name="region" required v-model="profile.region">
        <option value="" disabled="disabled">--Select {{ regionTitle }}--</option>
        <option v-for="option in computedOptions" :value="option.code">
          {{ option.name }}
        </option>
      </select>
      <div class="radio radio-primary" v-for="option in investorOptions">
        <input type="radio" class="form-control" name="investor_type" v-model="profile.investor_type" :value="option.type" required>
        <label>{{ option.label }}</label>
      </div>
      <button type="submit" class="btn btn-primary btn-md center-block margin-top-20">Create Investor</button>
    </div>
  </form>
    <label v-if="showResMessage">{{ resMessage }}</label>
  </div>
</template>

<script>
  import axios from "axios"
  import FieldError from "./FieldError";

export default {
  components : {
    FieldError
  },
  props: {
    locationOptions : Object
  },
  data() {
    return {
      profile: {
        first_name : '',
        last_name: '',
        email: '',
        country: 'CA',
        region: '',
        investor_type: '',
        add_existing: false,
      },
      user : '',
      resMessage: '',
      showResMessage: false,
      regionTitle: 'Province',
      investorOptions: [
        {
          type: 'accredited',
          label: 'an Accredited Investor – I meet financial tests or otherwise qualify'
        },
        {
          type: 'eligible',
          label: 'not an Accredited Investor – I want to invest in opportunities I can access'
        }
      ],
      errors: {
        first_name: '',
        last_name: '',
        email: '',
        country: '',
        region: '',
        investor_type: ''
      }
    }
  },
  methods : {
    createInvestor() {
      return axios.post('investor/register',  this.profile )
          .then(response => {
            if(this.user === '') {
              this.user = response.data.userData
            }
            this.resMessage = response.data.resMessage
            this.showResMessage = true
            this.$emit('profile-created',this.user)
            return Promise.resolve()
          })
          .catch(errors => {
            if(errors.response.data.errors.first_name && errors.response.data.errors.first_name !== '') {
              this.errors.first_name = errors.response.data.errors.first_name
            }
            if(errors.response.data.errors.last_name && errors.response.data.errors.last_name !== '') {
              this.errors.last_name = errors.response.data.errors.last_name
            }
            if(errors.response.data.errors.email && errors.response.data.errors.email !== '') {
              this.errors.email = errors.response.data.errors.email[0]
            }
            this.timer()
            return Promise.resolve()
          })
    },
    addExistingInvestor() {
      if(this.profile.add_existing === true) {
        return axios.post('investor/addExisting', this.profile)
          .then(response => {
            this.user = response.data.userData
            this.resMessage = response.data.resMessage
            this.showResMessage = true
            this.$emit('profile-created',this.user)
            return Promise.resolve()
          })
      }
    },
    timer() {
      setTimeout(() => {
        this.errors = {
          first_name: '',
          last_name: '',
          email: '',
          country: '',
          region: '',
          investor_type: ''
        }

      }, 10000)
    },
  },
  computed: {
    computedOptions() {
      if(this.profile.country === 'CA') {
        this.regionTitle = 'Province'
        this.profile.region = ''
        return this.locationOptions.caRegionOptions
      }
      if(this.profile.country === 'US') {
        this.regionTitle = 'State'
        this.profile.region = ''
        return this.locationOptions.usRegionOptions
      }
      if(this.profile.country !== 'US' || this.profile.country !== 'CA') {
        this.regionTitle = 'International'
        this.profile.region = ''
        return [{code: 'int',name: 'International'}]
      }
    }
  }
}
</script>